
import React, { useState } from 'react'

import { getHeaders } from '../../Services/ApiService'

import ImageUploader from '../ImageUploader/ImageUploader'
import ImageCropper from '../ImageCropper/ImageCropper'

import './ClientLogoUploader.scss'

type Props = {
    baseUrl?: string
    endpoint: string
    image: string
    onUpload: (image: string) => void
    disabled?: boolean
}

const ClientLogoUploader = (props: Props) => {

    const [ showUploader, setShowUploader ] = useState(false)

    const handleClick = () => {

        if (props.disabled) {

            return
        }

        setShowUploader(true)
    }

    const handleFileUploaded = (file: any) => {

        setShowUploader(false)
        props.onUpload(file)
    }

    return (
        <>
            <div data-testid="avatar-uploader" className="avatar-uploader">
              {!props.image && (
                <button
                  onClick={() => handleClick()}
                  className={`btn btn-normal-2 ${props.disabled ? 'disabled' : ''}`}
                >
                  Subir logo
                </button>
              )}
              {props.image && (
                <img
                    src={`${props.baseUrl}/${props.image}`}
                    alt="Client Logo"
                    onClick={() => handleClick()}
                    className={props.disabled ? 'disabled' : ''}
                />
              )}
            </div>

            <ImageUploader
                show={showUploader}
                onHide={() => setShowUploader(false)}
                headers={getHeaders()}
                baseUrl={props.baseUrl}
                url={`${props.baseUrl}${props.endpoint}`}
                type="client-logo"
                onUploadFile={(file: any) => handleFileUploaded(file) }
            />
        </>
    )
}

export default ClientLogoUploader
